// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"fcb3035f","815":"0322ef98"}[chunkId] + ".chunk.js";
};